import { request, requestBlob } from '@/shared/api';
import { withScopeQuery } from '@/shared/model/agent-scope';
export function fetchQueueBoard(scope) {
    return request(withScopeQuery('/api/v1/priority-queues/board', scope));
}
export function recordContact(placementId, note) {
    return request(`/api/v1/priority-queues/placements/${placementId}/contact`, {
        method: 'POST',
        body: JSON.stringify({ note }),
    });
}
export function deferPlacement(placementId, note) {
    return request(`/api/v1/priority-queues/placements/${placementId}/defer`, {
        method: 'POST',
        body: JSON.stringify({ note }),
    });
}
export function movePlacement(placementId, targetQueueId) {
    return request(`/api/v1/priority-queues/placements/${placementId}/move`, {
        method: 'POST',
        body: JSON.stringify({ targetQueueId }),
    });
}
export function closePlacement(placementId, note) {
    return request(`/api/v1/priority-queues/placements/${placementId}/close`, {
        method: 'POST',
        body: JSON.stringify({ note }),
    });
}
export function placeNewAgent(input) {
    return request('/api/v1/priority-queues/placements/new-agent', {
        method: 'POST',
        body: JSON.stringify(input),
    });
}
export function fetchPlacementCalls(placementId) {
    return request(`/api/v1/priority-queues/placements/${placementId}/calls`);
}
export function fetchPlacementCallRecording(placementId, entryId) {
    return requestBlob(`/api/v1/priority-queues/placements/${placementId}/calls/${entryId}/recording`);
}
